import { useState } from "react";
import { Link } from "wouter";
import { Logo } from "../lib/brand";
import { api } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null); setBusy(true);
    try {
      const r = await api.forgotPassword(email.trim());
      setSent(true);
      // In non-email environments the server echoes the reset URL so recovery still works.
      if (r?.resetUrl) setDevLink(r.resetUrl);
    } catch (err: any) { setError(err?.message || "Something went wrong. Please try again."); }
    finally { setBusy(false); }
  }

  return (
    <div className="min-h-[80vh] grid place-items-center container-x py-10">
      <div className="card p-6 sm:p-8 max-w-md w-full">
        <div className="flex justify-center mb-4"><Logo withTagline /></div>
        <h1 className="text-2xl font-extrabold text-navy text-center mb-1">Reset your password</h1>
        <p className="text-sm text-mut text-center mb-6">Enter your email and we'll send you a link to set a new password.</p>

        {sent ? (
          <div className="space-y-4">
            <div className="rounded-lg bg-brand-green/10 text-brand-greendark text-sm p-4 text-center">
              If an account exists for <span className="font-semibold">{email}</span>, a password-reset link is on its way. Check your inbox (and spam folder).
            </div>
            {devLink && (
              <div className="rounded-lg border border-line p-3 text-xs text-mut break-all">
                <div className="font-semibold text-navy mb-1">Development link</div>
                <Link href={devLink.replace(/^.*(\/reset-password.*)$/, "$1")} className="text-brand-red underline">{devLink}</Link>
              </div>
            )}
            <Link href="/login" className="btn-outline w-full">Back to sign in</Link>
          </div>
        ) : (
          <form className="space-y-3" onSubmit={submit}>
            <div><label className="label">Email</label>
              <input required type="email" className="field" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            {error && <p className="text-sm text-brand-red">{error}</p>}
            <button type="submit" disabled={busy} className="btn-red w-full disabled:opacity-60">{busy ? "Sending…" : "Send reset link"}</button>
            <p className="text-center text-sm text-mut">Remembered it? <Link href="/login" className="text-brand-red font-semibold">Sign in</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
